import {
  getFindAllVenueRentalConfigurationsQueryKey,
  useUpdateVenueRentalConfiguration,
  VenueConfigurationUnionType,
  VenueConfigurationVersionUnionType,
} from '@api';
import { useInvalidateQuery, useNotification } from '@common';
import { AxiosError } from 'axios';
import { RentalConfigurationFormValuesType } from '../../components';

const TRANS_PATH = 'NOTIFICATIONS.UPDATE_RENTAL_CONFIGURATION';

type UseUpdateRentalConfigurationArgsType = {
  venueId: string;
  version: string;
};

type HandleUpdateArgsType = {
  data: RentalConfigurationFormValuesType;
  configurationId: string;
};

type UseUpdateRentalConfigurationReturnType = {
  updateRentalConfiguration: (args: HandleUpdateArgsType) => Promise<void>;
};

export const useUpdateRentalConfiguration = ({
  venueId,
  version,
}: UseUpdateRentalConfigurationArgsType): UseUpdateRentalConfigurationReturnType => {
  const { showSuccess, showError } = useNotification();
  const { mutateAsync: mutateUpdate } = useUpdateVenueRentalConfiguration();
  const { invalidateQuery: invalidateConfigurationQueries } =
    useInvalidateQuery(
      getFindAllVenueRentalConfigurationsQueryKey(venueId, version)
    );

  const onSuccess = () => {
    showSuccess({
      title: `${TRANS_PATH}.SUCCESS.TITLE`,
      message: `${TRANS_PATH}.SUCCESS.MESSAGE`,
    });
    invalidateConfigurationQueries();
  };

  const onError = (error: AxiosError) => {
    showError({
      title: `${TRANS_PATH}.ERROR.TITLE`,
      message: `${TRANS_PATH}.ERROR.MESSAGE`,
      error: error,
    });
  };

  const updateRentalConfiguration = async ({
    data,
    configurationId,
  }: HandleUpdateArgsType) => {
    await mutateUpdate(
      {
        venueId,
        configurationId,
        data: {
          ...data,
          configuration: data.configuration as VenueConfigurationUnionType,
          version: data.version as VenueConfigurationVersionUnionType,
        },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { updateRentalConfiguration };
};
